import React from 'react';
import useAuth from '@hooks/authHook';

const AuthWrapper = ({ children }) => {
    useAuth();
    return <>{children}</>;
};

export default AuthWrapper;
